import { DO_CLICK_ACTIONS, DO_IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export interface TipWidgetImpressionParams {
    bookingId: string;
    orderId: string;
    widgetState: "default" | "collapsed";
    tiles?: Array<{
        position: number;
        name: string;
        details: string;
    }>;
}

export const impressionTipWidget = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { bookingId, orderId, widgetState, tiles }: TipWidgetImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action:
            widgetState === "default" ? DO_IMPRESSION_ACTIONS.TIP_WIDGET : DO_IMPRESSION_ACTIONS.TIP_WIDGET_COLLAPSED,
        context: JSON.stringify({ bookingId, orderId, widgetState, tiles: tiles ?? [] }),
    });
};

export const clickTipWidgetClose = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { bookingId, orderId }: { bookingId: string; orderId: string },
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action: DO_CLICK_ACTIONS.TIP_WIDGET_CLOSE,
        context: JSON.stringify({ bookingId, orderId }),
    });
};

export const clickTipPaymentOption = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    {
        bookingId,
        orderId,
        paymentMethod,
        position,
    }: { bookingId: string; orderId: string; paymentMethod: string; position: number },
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action: DO_CLICK_ACTIONS.TIP_PAYMENT_OPTION,
        label: paymentMethod,
        value: String(position),
        context: JSON.stringify({ bookingId, orderId, paymentMethod }),
    });
};

export const clickTipCta = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { bookingId, orderId }: { bookingId: string; orderId: string },
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action: DO_CLICK_ACTIONS.TIP_CTA,
        context: JSON.stringify({ bookingId, orderId }),
    });
};
